import { SkeletonItem, Card, CardHeader } from "@fluentui/react-components";

/**
 * Skeleton for the to-dos component
 * @returns 
 */
export default function TodosCardSkeleton() {

    return (
        <Card className="todo-card-skeleton">
            <CardHeader className="todo-card-header-skeleton"
                header={
                    <SkeletonItem appearance="translucent" className="todo-header-skeleton" shape="rectangle" size={16} />
                }
                description={
                    <SkeletonItem appearance="translucent" className="todo-description-skeleton" shape="rectangle" size={16} />
                }
            />
        </Card>
    );
}
